<template lang="pug">
b-modal#miniGameRewardOp(
  ref="miniGameRewardOp"
  :title="getTitle()"
  centered
  no-fade
  no-close-on-backdrop
  size="xl"
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    div.row.mb-2
      div.col-sm-12.col-md-4.col-lg-4
        .form-group.col-12.mb-1.px-0
          SubmitButton(
            :loading="loading"
            icon="fa fa-sync"
            :text="$t('ui.refresh')"
            type="button"
            @click="getOperatorMiniGameRewardList(true)"
            variant="primary"
            size="sm"
          )

    div.row
      div.col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="8%")
                  span(:title="$t('ui.reward_code')") {{ $t('ui.reward_code') }}
                th(width="8%")
                  span(:title="$t('ui.reward_name')") {{ $t('ui.reward_name') }}
                th(width="8%")
                  span(:title="$t('ui.reward_description')") {{ $t('ui.reward_description') }}
                th.text-right(width="8%")
                  span(:title="$t('ui.reward_probability')") {{ $t('ui.reward_probability') }}
                th.text-right(width="8%")
                  span(:title="$t('ui.reward')") {{ $t('ui.reward') }}
                th.text-center(width="5%" v-if="isEditMiniGameAccess")
                  span(:title="$t('ui.action')") {{ $t('ui.action') }}
            tbody.clusterize-content
              tr(v-if="miniGameRewardOpList.length == 0")
                td(colspan="8").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(info, index) in miniGameRewardOpList")
                td.text-center
                  span(:title="index + 1") {{ index + 1 }}
                td
                  span(:title="info.reward_code") {{ info.reward_code }}
                td
                  span(:title="info.reward_name") {{ info.reward_name }}
                td
                  span(:title="info.reward_description") {{ info.reward_description }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(info.reward_probability)" :title="info.reward_probability.toFixed(2)") {{ info.reward_probability.toFixed(2) }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(info.reward)" :title="info.reward") {{ info.reward }}
                td.actions.text-center.align-middle(v-if="isEditMiniGameAccess")
                  span.mr-2(v-if="item.available_edit")
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                      href="javascript:void(0)"
                      @click="onEdit(info)"
                      :title="$t('ui.edit')"
                      )


    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}

    editminigamerewardop(ref="editMiniGameRewardOp" :item="selectedMiniGameRewardOp" @clicked="afterEdit" @failed="handleFailedReward")

  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import editminigamerewardop from "@/components/siteeditor/miniGame/editMiniGameRewardOp.vue";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    editminigamerewardop
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      miniGameRewardOpList: [],
      selectedMiniGameRewardOp: null,
      gameType: null,
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditMiniGameAccess() {
      return this.$helpers.showActionButton("e_minigameop");
    }
  },
  methods: {
    getTitle() {
      if(this.item != null)
        return this.$t('ui.reward') + ' (' + this.$t('message.tooltips_gamereward', {max: this.item.max_game_reward}) + ')'

      return ''
    },
    onEdit(e) {
      e.game_type = this.item.game_type
      this.selectedMiniGameRewardOp = e;
      this.$refs.editMiniGameRewardOp.$refs.editMiniGameRewardOp.show();
    },
    getOperatorMiniGameRewardList: function() {
      let url = config.getOperatorMiniGameRewardListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_game_id: this.item.operator_game_id,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.miniGameRewardOpList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    afterEdit() {
      this.getOperatorMiniGameRewardList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_reward"), this.$t("message.success"), "success");
    },
    handleFailedReward(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.gameType = null
      this.miniGameRewardOpList = []
      this.selectedMiniGameRewardOp = null
    },
    shown: function() {
      this.miniGameRewardOpList = []
      this.selectedMiniGameRewardOp = null
      this.gameType = this.item.game_type
      this.getOperatorMiniGameRewardList();
    }
  }
};
</script>
